import React, { useState } from 'react';
import { api, setTokens as saveTokens } from './api/api';

const Login = ({ setTokens }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setLoading(true);
        try {
            const response = await api.post('/auth/authenticate', { email, password });
            const { access_token, refresh_token } = response.data;
            saveTokens(access_token, refresh_token);
            setTokens(response.data);
        } catch (err) {
            console.error('Auth error', err);
            setError('Invalid email or password.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="fb-login-page">
            <div className="fb-login-card">
                <div className="fb-login-logo">
                    <div className="fb-login-icon">F</div>
                    <div className="fb-login-brand">FOBASE</div>
                    <div className="fb-login-sub">2.0</div>
                </div>

                <form onSubmit={handleSubmit}>
                    <div className="fb-login-field">
                        <label className="fb-login-label">Login</label>
                        <input
                            className="fb-login-input"
                            type="text"
                            placeholder="username"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            autoComplete="username"
                        />
                    </div>

                    <div className="fb-login-field">
                        <label className="fb-login-label">Password</label>
                        <input
                            className="fb-login-input"
                            type="password"
                            placeholder="••••••••"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            autoComplete="current-password"
                        />
                    </div>

                    <button className="fb-login-btn" type="submit" disabled={loading}>
                        {loading ? 'Signing in…' : 'Sign in'}
                    </button>

                    {error && <div className="fb-login-error">{error}</div>}
                </form>
            </div>
        </div>
    );
};

export default Login;
